import { IFamily } from '@gn-audio/core/api/product-catalogue/models/family';
import { Component, Input, OnChanges, Output } from 'angular-ts-decorators';

import template from './product-comparison-product-selector.component.html';

@Component({
  selector: 'productComparisonProductSelector',
  template,
})
export class ProductComparisonProductSelectorComponent implements OnChanges {
  @Input() public products?: IFamily[];
  @Input() public excludeProductId?: number;
  @Input() public disabled = false;
  @Input() public preSelectedProductId?: number;

  @Output() public onProductSelect?: (args: { product: IFamily; }) => void;

  public selectedProduct?: IFamily;
  public productListVisible = false;

  public get reducedProducts(): IFamily[] {
    return this.products?.filter((x: IFamily) => x.familyId !== this.excludeProductId) || [];
  }

  public ngOnChanges() {
    if (this.preSelectedProductId) {
      this.selectedProduct = (this.products || []).filter((x: IFamily) => x.familyId === this.preSelectedProductId)[0];
    }

    if (!this.selectedProduct) {
      this.selectedProduct = this.reducedProducts[0];
    }
  }

  public toggleProductList() {
    if (this.productListVisible) {
      this.closeProductList();
    } else {
      this.openProductList();
    }
  }

  public openProductList() {
    this.productListVisible = !this.disabled;
  }

  public closeProductList() {
    this.productListVisible = false;
  }

  public selectProduct(product: IFamily) {
    const productChanged = (this.selectedProduct !== product);
    this.selectedProduct = product;
    this.closeProductList();
    if (this.onProductSelect && productChanged) {
      this.onProductSelect({ product });
    }
  }
}
